<template>
  <search
    ref="search"
    class="sales-history-search"
    source="salesarchive"
    sort="date"
    v-bind="$attrs"
    :placeholder="placeholder"
    v-on="$listeners"
  >
    <template #default="slotProps">
      <sales-list-item split :item="slotProps.item">
        <verified-icon v-if="slotProps.item.cardId" />
      </sales-list-item>
    </template>
  </search>
</template>

<script>
import Search from '@/components/Search';

import SalesListItem from '@cardladder/shared/components/SalesListItem';
import VerifiedIcon from '@cardladder/shared/components/VerifiedIcon';

export default {
  components: {
    Search,
    SalesListItem,
    VerifiedIcon,
  },

  props: {
    placeholder: {
      type: String,
      default: 'Search sales history',
    },
  },

  methods: {
    focus() {
      this.$refs.search.focus();
    },

    clear() {
      this.$refs.search.clear();
    },
  },
};
</script>
